.s-quick-buy {
  &-button {
    .s-button-text {
      display: flex;
    }
  }

  &-apple-pay {

  }
}

apple-pay-button {
  --apple-pay-button-width: 100%;
  --apple-pay-button-height: 40px;
  --apple-pay-button-border-radius: .75rem;
  // --apple-pay-button-padding: 0px 5px;
  --apple-pay-button-box-sizing: content-box;
}
